import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// ISO country code → emoji flag (built from regional indicator symbols, no images needed).
const flagFor = (iso) => {
  if (!iso || iso.length !== 2) return '';
  const codePoints = iso.toUpperCase().split('').map(c => 127397 + c.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

// Curated list of prefixes (priority countries first). Value uses prefix
// alone so existing data stays compatible with the previous Select.
export const PHONE_PREFIXES = [
  { iso: 'ES', code: '+34',  label: 'España' },
  { iso: 'FR', code: '+33',  label: 'Francia' },
  { iso: 'DE', code: '+49',  label: 'Alemania' },
  { iso: 'GB', code: '+44',  label: 'Reino Unido' },
  { iso: 'IT', code: '+39',  label: 'Italia' },
  { iso: 'PT', code: '+351', label: 'Portugal' },
  { iso: 'NL', code: '+31',  label: 'Países Bajos' },
  { iso: 'BE', code: '+32',  label: 'Bélgica' },
  { iso: 'CH', code: '+41',  label: 'Suiza' },
  { iso: 'AT', code: '+43',  label: 'Austria' },
  { iso: 'IE', code: '+353', label: 'Irlanda' },
  { iso: 'US', code: '+1',   label: 'EE. UU. / Canadá' },
  { iso: 'MX', code: '+52',  label: 'México' },
  { iso: 'AR', code: '+54',  label: 'Argentina' },
  { iso: 'CL', code: '+56',  label: 'Chile' },
  { iso: 'CO', code: '+57',  label: 'Colombia' },
  { iso: 'PE', code: '+51',  label: 'Perú' },
  { iso: 'UY', code: '+598', label: 'Uruguay' },
  { iso: 'BR', code: '+55',  label: 'Brasil' },
  { iso: 'MA', code: '+212', label: 'Marruecos' },
];

/**
 * Compact phone prefix select with flag emoji. Width ~76px (just shows flag + code).
 */
export default function PhonePrefixSelect({ value, onValueChange, testId }) {
  const current = PHONE_PREFIXES.find(p => p.code === value) || PHONE_PREFIXES[0];
  return (
    <Select value={value || '+34'} onValueChange={onValueChange}>
      <SelectTrigger
        className="w-[100px] flex-shrink-0 px-2 h-9 rounded-md border border-input bg-transparent text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
        data-testid={testId}
      >
        <SelectValue>
          <span className="inline-flex items-center gap-1.5">
            <span className="text-base leading-none">{flagFor(current.iso)}</span>
            <span className="text-sm">{current.code}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {PHONE_PREFIXES.map(p => (
          <SelectItem key={p.iso} value={p.code}>
            <span className="inline-flex items-center gap-2">
              <span className="text-base leading-none">{flagFor(p.iso)}</span>
              <span className="font-medium">{p.code}</span>
              <span className="text-xs text-muted-foreground">{p.label}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
